import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'agenda-customer-ui-numbered-title',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './numbered-title.component.html',
  styleUrls: ['./numbered-title.component.scss'],
})
export class NumberedTitleComponent {
  number = input.required<string>();
  title = input.required<string>();
  label = input<string>('');
  subtitle = input.required<string>();
}
